<template>
    <div>
        <section class="sodastream">
            <div class="sodastream--mobile">
                <div>
                    <img
                    src="./../assets/sodastream/SodaStream_BublyDrops_Logo@2x.png"
                    alt="Soda Stream Logo"
                    />
                </div>
                <div class="">
                    <img
                        src="./../assets/sodastream/Headline@2x.png"
                        alt="Make Fresh Sparking Water at Home with New Bubly Drops"
                    />
                </div>
            </div>
            <div class="sodastream__content">
                <div class="sodastream__content__left">
                    <img
                        src="./../assets/sodastream/Machine@2x.png"
                        alt="Soda Stream Machine"
                    />
                </div>
                <div class="sodastream__content__right">
                    <div class="sodastream__content__right__top">
                        <div>
                            <img
                                src="./../assets/sodastream/SodaStream_BublyDrops_Logo@2x.png"
                                alt="Soda Stream Logo"
                            />
                        </div>
                        <div>
                            <img
                        src="./../assets/sodastream/Headline@2x.png"
                        alt="Make Fresh Sparking Water at Home with New Bubly Drops"
                        />                       
                    </div>
                    </div>
                    <div class="sodastream__content__right__middle">
                        <a href="https://sodastream.com/bubly" target="_blank">
                        <button
                            class="buynow" tabindex="-1"
                        >
                            buy now
                            <span class="screen-reader-only"> Soda stream</span>
                            <span class="screen-reader-only"> (opens in a new tab)</span>
                        </button> 
                        </a>
                    </div>

                    <div class="sodastream__content__right__bottom">
                        <div>
                            <img
                                src="./../assets/sodastream/BlackBerry@2x.png"
                                alt="40ml Blackberry Bubly Bottle"
                            />
                            </div>
                        <div>
                            <img
                                src="./../assets/sodastream/Bottles@2x.png"
                                alt="40ml Bubly Flavor Bottles"
                            />
                        </div>
                    </div>
               </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: "bounce",
    methods: {
        triggerModal: (e) => {
            const container = e.target.getAttribute("data-destini-container");
            const association = e.target.getAttribute("data-destini-association");
            destini.init(container);
            destini.loadWidget(association);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./../variables";

html,
body {
    -webkit-overflow-scrolling: touch !important;
    overflow: auto !important;
    height: 100% !important;

}
.sodastream {

    position: relative;
    width:100%;
    background: url(./../assets/sodastream/BG.png) bottom no-repeat, url(./../assets/sodastream/Dots_l@3x.png) left -40px top -40px no-repeat,url(./../assets/sodastream/Dots_R@3x.png) right -40px top -40px no-repeat, #00abe9;
    background-size: 100% 14%, 15%, 15%;
    padding-top:3rem;
    

    img {
        align-self: flex-end;
        -webkit-backface-visibility: hidden; 
        -ms-transform: translateZ(0); /* IE 9 */
        -webkit-transform: translateZ(0); /* Chrome, Safari, Opera */
        transform: translateZ(0);
    }

    &--mobile {
        display:flex;
        display: -ms-flexbox;
        display: -webkit-flex;
        width:80%;
        flex-direction:column;
        margin:0 auto;
        padding-bottom:4rem;
        text-align: left;

        :first-child{
            width:90%;
            padding-bottom:1%;
        }



        @media (min-width: 768px) {

            display:none;


        }
    }

    & {
            background: url(./../assets/sodastream/BG.png) bottom no-repeat, url(./../assets/sodastream/Dots_l@3x.png) left -5vw bottom 100vw no-repeat,url(./../assets/sodastream/Dots_R@3x.png) right -5vw bottom 70vw no-repeat, #00abe9;
            background-size: 100% 10%, 20vw, 20vw;
    }



    @media (min-width: 768px) {
            background: url(./../assets/sodastream/BG.png) bottom no-repeat, url(./../assets/sodastream/Dots_l@3x.png) left -4vw top -14vw no-repeat,url(./../assets/sodastream/Dots_R@3x.png) right -6vw top 2vw no-repeat, #00abe9;
            background-size: 100% 12%, 20vw, 20vw;

    }

    @media (min-width: 1024px) {
            background: url(./../assets/sodastream/BG.png) bottom no-repeat, url(./../assets/sodastream/Dots_l@3x.png) left -2% top -4% no-repeat,url(./../assets/sodastream/Dots_R@3x.png) right -2vw top -3vw no-repeat, #00abe9;
            background-size: 100% 12%, 15vw, 15vw;

    }

    @media (min-width: 1366px) {
    }

    @media (min-width: 1920px) {
        // height: 980px;
    }

    @media (min-width: 2560px) {
       
            background: url(./../assets/sodastream/BG.png) bottom no-repeat, url(./../assets/sodastream/Dots_l@3x.png) left 0 top 0 no-repeat,url(./../assets/sodastream/Dots_R@3x.png) right 0 top 0 no-repeat, #00abe9;
            background-size: 100% 14%, 15%, 15%;
       
    }
    button {


        //ipad
        // position: relative;
        // width: 136;
        // height: 31;
        // border-radius: 20px;
        // border: none;
        // background-color: #fff;
        // font-size: 20px;
        // font-weight: bold;
        // color: #00abe9;
        // cursor: pointer;
        // z-index: 2;

        //desktop
        position: relative;
        width: 113px;
        height: 25px;
        border-radius: 19px;
        border: none;
        background-color: #fff;
        font-size: 14px;
        font-weight: bold;
        color: #00abe9;
        cursor: pointer;
        z-index: 2;
        @media (min-width: 768px) {
            width: 136px;
            height: 31px;
        }

        &:hover {
            background-color: #553280;
            color: #fff;
        }
    }

    &__content {
        display:flex;
        display: -ms-flexbox;
        display: -webkit-flex;
        width:90%;
        margin:0 auto;
        // max-width:1120px;

        @media (min-width: 1024px) {
            
                width:60%;
            
        }
        @media (min-width: 2560px) {
           
                max-width:60%;
          
        }

        &__left {
            
            position:relative;
            flex: 0 0 36%;
            -ms-flex: 0 0 36%;
            margin-top:auto;

            @media (min-width: 1024px) {
               
                    
                   flex: 0 0 21%;
                    -ms-flex: 0 0 21%;

               
            }

            &::before {
                position:absolute;
                top:-10vw;
                left:-38vw;
                content:"";
                background: url(./../assets/sodastream/Glow.png);
                width: 110vw;
                height: 110vw;
                background-repeat: no-repeat;
                background-position: left;
                background-size:100%;
                
                @media (min-width: 1024px) {
                    
                        width: 50vw;
                        height: 50vw;
                        top:-10vw;
                        left:-21vw;
                   
                }

            }
        }

        &__right {
            display:flex;
            display: -ms-flexbox;
            display: -webkit-flex;
            flex-direction: column;
            flex:1 0 60%;
            @media (min-width: 1024px) {
               
                    margin-top:auto;
              
            }

            &__top {
                
                display:none;

                @media (min-width: 768px) {
                    
                        display:flex;
                        flex-direction:column;
                        // width: 100%;
                        padding:10% 0% 10% 10%;
                        text-align:left;
                        // min-height: 2vh; 
                        // height:1px;
                        :first-child{
                            width:100%;
                            padding-bottom:3%;
                        }
                        
                   
                }

                @media (min-width: 1024px) {
                    width: 90%;
                    padding:10% 0% 5% 12%;
                    // height:1px;

                    :first-child{
                         width:80%;
                         padding-bottom:1%;
                    }
                    

                }

            }

            &__middle {
                display: flex;
                display: -ms-flexbox;
                display: -webkit-flex;
                order:0;
                -ms-flex-order: 0;
                -webkit-order: 0;
                justify-content: center;
                margin-left: -8%;
                

                @media (min-width: 768px) {
                    
                        flex:1 0 0%;
                        -ms-flex: 1 0 0%;
                        align-items: center;
                        -webkit-box-align: center; 
                        -ms-flex-align: center; 
                        order:initial;
                        -ms-flex-order: initial;
                        -webkit-order: initial;
                        margin-top:-9vw;
                   
                }

                @media (min-width: 1024px) {
                    
                        flex:0;
                        align-items: flex-end;
                        -webkit-box-align: flex-end; 
                        -ms-flex-align: flex-end; 
                        -webkit-box-pack: center; 
                        -ms-flex-pack: center; 
                        justify-content: center;
                        margin-top: auto;
                        padding-left: 25vw;
                   
                }
            }

            &__bottom {
                display: flex;
                // flex:0 0 100%;
                margin-top: auto;
                width: 85%;
                
                @media (min-width: 1024px) {
                            width:100%;
                       
                    }
                div {

                    &:last-child {
                        display:none;
                        img {
                        width:253.098%;
                        // height:253%;
                        }

                    }

                    @media (min-width: 1024px) {
                        &:last-child {        
                            display:flex;
                            display: -ms-flexbox;
                            display: -webkit-flex;
                        }
                    }
                }
            }

            
        }

    }
}

.modal {
    padding-top: 50px;
}
#widget-modal .modal-body {
    text-align: center;
    width: 100%;
    max-width: 840px;
    min-width: 300px;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    max-height: 750px !important;
    padding: 0px;
}
.modal-open .modal {
    background-color: rgba($color: #000000, $alpha: 0.6);
}
#widget-modal .close {
    position: relative;
    margin-right: -30px;
    color: #fff;
    margin-top: -30px;
    font-size: 40px;
    outline: 0;

    &--mobile{
        position: absolute;
        margin: 0 auto;
        top: 3px;

        @media (min-width: 768px) {
            display: none;
        }
    }
}

#destinidiv {
    background: #fff;
    width: 100%;
    overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/SodaStream.vue